export default __webpack_public_path__ + "static/media/first_meet.a6105537.jpg";